export default "__VITE_ASSET__DWmQGDFL__"